// extracted by mini-css-extract-plugin
module.exports = {"container":"avatarLoadingOverlay_container__F2KDy"};